import React from "react";
import { Link } from "react-router-dom";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import CardNotaireDashboard from "./CardNotaireDashboard";

const NotaireStatut = ({ type, statut, affaire }) => {

    return (
        <section>
            {statut === "en recherche de notaire" &&
                <>
                    <section className="mb-10">
                        <div className="rounded-md bg-gradient-to-r from-teal-400 to-teal-300 p-4">
                            <div className="flex items-center">
                                <div className="shrink-0">
                                    <InformationCircleIcon aria-hidden="true" className="size-6 text-white" />
                                </div>
                                <div className="ml-3 flex-1 md:flex md:justify-between items-center">
                                    <p className="text-lg text-white m-0">Deux notaires sont disponibles pour votre dossier</p>
                                    {type === "immo" &&
                                        <Link to={`/app/notaires/immo/${affaire.id}`} className="btn-main no-underline">
                                            Choisissez votre notaire
                                        </Link>
                                    }
                                    {type === "pma" &&
                                        <Link to={`/app/notaires/pma/${affaire.id}`} className="btn-main no-underline">
                                            Choisissez votre notaire
                                        </Link>
                                    }
                                    {type === "mariage" &&
                                        <Link to={`/app/notaires/mariage/${affaire.id}`} className="btn-main no-underline">
                                            Choisissez votre notaire
                                        </Link>
                                    }
                                    {type === "pacs" &&
                                        <Link to={`/app/notaires/pacs/${affaire.id}`} className="btn-main no-underline">
                                            Choisissez votre notaire
                                        </Link>
                                    }
                                    {type === "aucune_demarche" &&
                                        <Link to={`/app/notaires/aucune_demarche/${affaire.id}`} className="btn-main no-underline">
                                            Choisissez votre notaire
                                        </Link>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            }

            {(
                statut === "notaire trouvé" ||
                statut === "vérification avant attribution" ||
                statut === "en cours d'attribution"
            ) && (
                    <>
                        <p className='mt-1 text-lg text-gray-500'><span role="img">👋</span> Votre dossier est pris en charge par votre notaire.</p>
                        <CardNotaireDashboard nom={affaire.nom_from_notaire} prenom={affaire.prenom_from_notaire} email={affaire.email_from_notaire} telephone={affaire.telephone_from_notaire} adresse={affaire.adresse_from_notaire} cp={affaire.code_postal_from_notaire} ville={affaire.ville_from_notaire} photo={affaire.photo_profil_from_notaire} />
                    </>
                )}

        </section>
    );
};

export default NotaireStatut;